import {ExerciseGoalType} from "../../../../core/models/ExerciseGoalType";

export function getGoalPercentage(goal) {
	if (goal.dateCompleted) return 100;
	if (!goal.currentLog) return 0;

	const typeId = goal.type.id;
	let ratio = 0;

	switch (typeId) {
		case ExerciseGoalType.WeightAndRepsGoal:
			ratio = Math.min(
				goal.currentLog.values[0] / goal.values[0],
				goal.currentLog.values[1] / goal.values[1]
			);
			break;
		case ExerciseGoalType.WeightGoal:
			ratio = goal.currentLog.values[0] / goal.values[0];
			break;
		case ExerciseGoalType.RepsGoal: {
			const val = goal.currentLog.values.length === 1
				? goal.currentLog.values[0]
				: goal.currentLog.values[1];
			ratio = val / goal.values[0];
			break;
		}
		case ExerciseGoalType.DistanceAndTimeGoal:
			ratio = Math.min(
				goal.currentLog.values[0] / goal.values[0],
				goal.currentLog.values[1] / goal.values[1]
			);
			break;
		case ExerciseGoalType.DistanceGoal:
			ratio = goal.currentLog.values[0] / goal.values[0];
			break;
		case ExerciseGoalType.TimeGoal: {
			const val = goal.currentLog.values.length === 1
				? goal.currentLog.values[0]
				: goal.currentLog.values[1];
			ratio = val / goal.values[0];
			break;
		}
		case ExerciseGoalType.WeightAndTimeGoal:
			ratio = Math.min(
				goal.currentLog.values[0] / goal.values[0],
				goal.currentLog.values[1] / goal.values[1]
			);
			break;
	}

	return Math.min(100, Math.round(100 * ratio));
}
